import { FC, PropsWithChildren, useLayoutEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

interface ISchemeCanvasProps {
  fit: boolean;
  width?: number;
  height?: number;
}

export const SchemeCanvas: FC<PropsWithChildren<ISchemeCanvasProps>> = ({ fit, width, height, children }) => {
  const viewportRef = useRef<HTMLDivElement>(null);
  const [viewport, setViewport] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const element = viewportRef.current;
    if (!fit || !element) return;

    const measure = () => {
      setViewport(previous =>
        previous.width === element.clientWidth && previous.height === element.clientHeight
          ? previous
          : { width: element.clientWidth, height: element.clientHeight },
      );
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [fit]);

  const scale = width && height ? Math.min(1, viewport.width / width, viewport.height / height) : 0;

  return (
    <Box
      ref={viewportRef}
      sx={
        fit
          ? { position: "relative", width: "100%", height: "100%", minWidth: 0, minHeight: 0, overflow: "hidden" }
          : { display: "contents" }
      }
    >
      <Box
        sx={
          fit
            ? {
                position: "absolute",
                width,
                height,
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                visibility: scale > 0 ? "visible" : "hidden",
              }
            : { position: "relative", display: "inline-block" }
        }
      >
        {children}
      </Box>
    </Box>
  );
};
